import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'
import { setInfoKey } from '../../api/information-collection/actions'


export const payerTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS', 'SET_CC', 'REMOVE_CC', 'SET_PAYER', 'SET_PAYMENT_METHOD'], 'PAYERS');



export const storeTempCC = (virtualCardObj, payerId) => {
    return {
        type: payerTypes.SET_CC,
        virtualCard: virtualCardObj,
        payerId: payerId,
    };
};

export const removeTempCC = (payerId) => {
    return {
        type: payerTypes.REMOVE_CC,
        payerId: payerId,
    };
};

export const createPayerVirtualcard = (paymentMethod, payer, virtualCard) => {
    return {
        type: payerTypes.SET_PAYER,
        paymentMethod: paymentMethod,
        payer: payer,
        virtualCard: virtualCard,
    };
};

export const createPayerDepositSlip = (paymentMethod, payer, paperSelection) => {
    return {
        type: payerTypes.SET_PAYER,
        paymentMethod: paymentMethod,
        payer: payer,
        paperSelection: paperSelection,
    };
};

export const mapProductToPayer = (customerId, productCode, payer) => {
    return {
        type: payerTypes.SET_PAYMENT_METHOD,
        customerId: customerId,
        productCode: productCode,
        payer: payer
    };
};